import React from 'react';
import './web3EasySection.scss';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Navigation, EffectCoverflow, Mousewheel, Autoplay } from 'swiper/modules';

const Web3EasySection = () => {
	return (
		<div className="web3Easy">
			<div className="web3Easy__title">
				<h2>We make WEB3 easy for you</h2>
			</div>
			<div className="web3Easy__content">
				<Swiper
					effect={'coverflow'}
					grabCursor={true}
					centeredSlides={true}
					loop={true}
					slidesPerView={4}
					initialSlide={2}
					onSlideChange={(swiper: any) => {
					}}
					coverflowEffect={{
						rotate: 0,
						stretch: -24,
						depth: 70,
						modifier: 3,
						slideShadows: false,
					}}
					autoplay={{
						delay: 4000,
						disableOnInteraction: false,
					}}
					mousewheel={true}
					modules={[EffectCoverflow, Navigation, Mousewheel, Autoplay]}
					className="swiper_container"
				>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/SomethingCard.webp`} alt={'Something card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Easy launch and token trading via <p className="web3Easy__content_item_data_info_color">something.cool</p></h2>
									<span>Launch, trade, earn with liquidity provider and build community right inside the platform.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://www.something.cool/?page=0&type=all&sortBy=timestamp&order=desc&list=0", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/TradingCard.webp`} alt={'Trading card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Easy trading via <p className="web3Easy__content_item_data_info_color">NFD Trading Bots</p></h2>
									<span>Fast and convenient token trading in different networks right inside Telegram.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://www.nfd.gg/nfd-trade-bots", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/PlatformCard.webp`} alt={'Platform card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Earn on Alpha with <p className="web3Easy__content_item_data_info_color">NFD Platform</p></h2>
									<span>All the activities of Web-3 space in one place. Instructions, announcements and news on each project - get all the information in a clear format and as quickly as possible.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://app.nfd.gg/ru", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/ArmorCard.webp`} alt={'Armor card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Secure delegation of work through <p className="web3Easy__content_item_data_info_color">NFD Armor</p></h2>
									<span>Check Your Scroll AirDrop farming stats.</span>
								</div>
								<div className="web3Easy__content_item_data_link">
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/CombineCard.webp`} alt={'Combine card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Automate farming with <p className="web3Easy__content_item_data_info_color">NFD Combine</p></h2>
									<span>Automatic and convenient airdrop farming through one app to multiple wallets.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://combine.nfd.gg/", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>

					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/SomethingCard.webp`} alt={'Something card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Easy launch and token trading via <p className="web3Easy__content_item_data_info_color">something.cool</p></h2>
									<span>Launch, trade, earn with liquidity provider and build community right inside the platform.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://www.something.cool/?page=0&type=all&sortBy=timestamp&order=desc&list=0", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/TradingCard.webp`} alt={'Trading card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Easy trading via <p className="web3Easy__content_item_data_info_color">NFD Trading Bots</p></h2>
									<span>Fast and convenient token trading in different networks right inside Telegram.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://www.nfd.gg/nfd-trade-bots", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/PlatformCard.webp`} alt={'Platform card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Earn on Alpha with <p className="web3Easy__content_item_data_info_color">NFD Platform</p></h2>
									<span>All the activities of Web-3 space in one place. Instructions, announcements and news on each project - get all the information in a clear format and as quickly as possible.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://app.nfd.gg/ru", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/ArmorCard.webp`} alt={'Armor card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Secure delegation of work through <p className="web3Easy__content_item_data_info_color">NFD Armor</p></h2>
									<span>Check Your Scroll AirDrop farming stats.</span>
								</div>
								<div className="web3Easy__content_item_data_link">
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
					<SwiperSlide>
						<div className="web3Easy__content_item">
							<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/CombineCard.webp`} alt={'Combine card'}/>
							<div className="web3Easy__content_item_data">
								<div className="web3Easy__content_item_data_info">
									<h2>Automate farming with <p className="web3Easy__content_item_data_info_color">NFD Combine</p></h2>
									<span>Automatic and convenient airdrop farming through one app to multiple wallets.</span>
								</div>
								<div className="web3Easy__content_item_data_link" onClick={() => window.open("https://combine.nfd.gg/", "_blank")}>
									<span>Learn more</span>
									<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/LinkArrow.svg`} alt={'Link'}/>
								</div>
							</div>
						</div>
					</SwiperSlide>
				</Swiper>
				{/*<div className={`web3Easy__content_place`}>*/}
				{/*	<img src={`${process.env.PUBLIC_URL}/assets/images/web3easy/DottedArrow.svg`}  alt={'Dotted arrow'}/>*/}
				{/*	<div className="web3Easy__content_place_text">*/}
				{/*		<span>Place the text here</span>*/}
				{/*	</div>*/}
				{/*</div>*/}
			</div>
		</div>
	);
};

export default Web3EasySection;